export enum CreateProductChannel {
    RedeemCode = "redeem-code",
    ShopifyPurchase = "shopify-purchase",
    ImportedPurchase = "imported-purchase",
    FromPharmacy = "pharmacy",
}